type IdOrEntity = string | { _id?: string; id?: string; name?: string; playerName?: string; [key: string]: unknown } | null | undefined;

export interface NormalizedPlayerOfMatch {
  player: string | null;
  team: string | null;
  playerName: string | null;
  teamName: string | null;
}

const idFrom = (value: IdOrEntity): string | null => {
  if (typeof value === "string") return value;
  return value?._id ?? value?.id ?? null;
};

const nameFrom = (value: IdOrEntity): string | null => {
  if (typeof value === "string") return null;
  return value?.name ?? value?.playerName ?? null;
};

export const normalizePlayerOfMatch = (value: { player?: IdOrEntity; team?: IdOrEntity } | null | undefined): NormalizedPlayerOfMatch => ({
  player: idFrom(value?.player),
  team: idFrom(value?.team),
  playerName: nameFrom(value?.player),
  teamName: nameFrom(value?.team),
});
